export default "__VITE_ASSET__5bd67e3a__"